var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"columns is-mobile is-multiline"},[_c('div',{staticClass:"column is-full"},[_c('window',{attrs:{"title":"404"}},[_c('error-404')],1)],1),_c('div',{staticClass:"column is-full"},[_c('window',{attrs:{"title":"500"}},[_c('error-500')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }